'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { IntroSectionText } from './IntroSectionText';
import { IntroSectionVideo } from './IntroSectionVideo';
import { useContainerScale } from './useContainerScale';
import { videoPositions } from './IntroSectionDesktop.data';
import { motion } from 'motion/react';
import { text } from '@onbeam/business-styled-system/patterns';

export const IntroSectionDesktop = ({ className }: { className?: string }) => {
  const { containerRef, scale } = useContainerScale();

  return (
    <motion.div
      ref={containerRef}
      className={cx(
        css({
          position: 'relative',
          w: 'full',
          h: 'auto',
          smDown: { display: 'none' },
        }),
        className,
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4 }}
    >
      <svg
        width="800"
        height="332"
        viewBox="0 0 800 332"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={css({
          w: 'full',
          h: 'full',
        })}
      >
        <IntroSectionText x={144} y={32}>
          At the intersection of
        </IntroSectionText>
        <IntroSectionText x={144} y={86}>
          artificial intelligence,
        </IntroSectionText>
        <IntroSectionText x={144} y={142}>
          trading
        </IntroSectionText>
        <IntroSectionText x={358} y={142}>
          & blockchain
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={144}
          y={194}
        >
          Beam operates as an
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={144}
          y={250}
        >
          innovation lab
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={476}
          y={250}
        >
          pushing
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={144}
          y={304}
        >
          the digital frontier.
        </IntroSectionText>
      </svg>
      {videoPositions.map((video) => (
        <IntroSectionVideo key={video.name} scale={scale} {...video} />
      ))}
    </motion.div>
  );
};
